import React from 'react';
import cardStyle from './card.module.css';
import AniLink from 'gatsby-plugin-transition-link/AniLink';

export default props => (
  <div
    className={cardStyle.card_container}
    data-aos="fade-up"
    data-aos-delay={props.animeOrder * 100}
  >
    <AniLink cover bg="#fba515" to={props.cardUrl} className={cardStyle.link}>
      <img className={cardStyle.card_img} src={props.cardIcon} alt={props.cardTitle} />
      <h4>{props.cardTitle}</h4>
      <p>{props.cardText}</p>
    </AniLink>
  </div>
);
